import { useState, useEffect } from "react";
import { useQuery } from "react-query";
import { useSearchParams } from "react-router-dom"; // Dodajte ovaj import
import MainCard from "components/layout/MainCard/MainCard";
import AnanlyticBlock from "./AnalyticBlock/AnalyticBlock";
import LoadingWrapper from "components/Loading/LoadingWrapper";
import AccountBalanceWalletOutlinedIcon from "@mui/icons-material/AccountBalanceWalletOutlined";
import SouthWestRoundedIcon from "@mui/icons-material/SouthWestRounded";
import NorthEastRoundedIcon from "@mui/icons-material/NorthEastRounded";
import EventAvailableOutlinedIcon from "@mui/icons-material/EventAvailableOutlined";
import useAPI from "hooks/useAPI";
import { currencyFormat } from "helpers/functions";
import scss from "./AnalitycCard.module.scss";
import { useTranslation } from "react-i18next";

import DataTable from "components/DataTable/DataTable";
import SearchBar from "components/UI/SearchBar";
import PaginationUI from "../../components/UI/PaginationUI";
import SidebarHeader from "../../components/layout/WithFixedSidebar/SidebarHeader/SidebarHeader";
import calculatorMoneyIcon from "../../assets/images/icons/calculator-money.svg";
import tblFields from "./tblFields.json";

const AnalyticCardPage = () => {
    const { t } = useTranslation();
    const [searchParams, setSearchParams] = useSearchParams();

    const api = useAPI();
    const apiPath = "/analytics-card";
    const [search, setSearch] = useState("");
    const [limit, setLimit] = useState(20);

    const [page, setPage] = useState(() => {
        const pageParam = searchParams.get("page");
        return pageParam ? parseInt(pageParam) : 1;
    });

    const [currentPage, setCurrentPage] = useState(1);

    const { data: dataSummary, isLoading: isLoadingSummary } = useQuery(["dataSummary"], () => api.get(apiPath + "/summary"));
    const {
        data: dataFinancialCard,
        isLoading: isLoadingFinancialCard,
        refetch: refetchFinancialCard,
    } = useQuery(["dataFinancialCard", page, limit], () => api.list(apiPath + "/financial-card/table", { search, page, limit }));
    const { data: dataFinancialCardLastTimeUpdate } = useQuery(["dataFinancialCardLastTimeUpdate"], () => api.get(apiPath + "/financial-card/last-time-update"));

    const formatSummaryAmount = (value) => currencyFormat(value == null || value === "" || !Number.isFinite(Number(value)) ? 0 : value, dataSummary?.currency);

    useEffect(() => setCurrentPage(dataFinancialCard?.pagination.selected_page ?? 1), [dataFinancialCard, page, dataFinancialCard?.pagination.selected_page]);

    useEffect(() => {
        refetchFinancialCard();
    }, [page, limit, search, refetchFinancialCard]);

    useEffect(() => {
        const newSearchParams = new URLSearchParams(searchParams);
        if (page === 1) {
            newSearchParams.delete("page");
        } else {
            newSearchParams.set("page", page.toString());
        }
        setSearchParams(newSearchParams);
    }, [page, searchParams, setSearchParams]);

    return (
        <MainCard>
            <SidebarHeader title={t("global-analytic_card-title")} icon={calculatorMoneyIcon} mobileOnly />
            <div className="page-container">
                <div className={`p page-content`}>
                    <h4 className={`h-underline ${scss.desktopTitle}`}>{t("global-analytic_card-title")}</h4>
                    <LoadingWrapper isLoading={isLoadingSummary}>
                        <div className={scss.analyticsContainer}>
                            <AnanlyticBlock
                                title={t("global-analytic_card-product_thumb-balance")}
                                value={formatSummaryAmount(dataSummary?.saldo)}
                                icon={AccountBalanceWalletOutlinedIcon}
                                tone="stone"
                            />
                            <AnanlyticBlock
                                title={t("global-analytic_card-product_thumb-in_currency")}
                                value={formatSummaryAmount(dataSummary?.debt_in_currency)}
                                icon={SouthWestRoundedIcon}
                                tone="sage"
                            />
                            <AnanlyticBlock
                                title={t("global-analytic_card-product_thumb-out_of_currency")}
                                value={formatSummaryAmount(dataSummary?.debt_out_currency)}
                                icon={NorthEastRoundedIcon}
                                tone="slate"
                            />
                            <AnanlyticBlock
                                title={t("global-analytic_card-product_thumb-approved_on")}
                                value={dataSummary?.debt_days == null || dataSummary?.debt_days === "" ? 0 : dataSummary.debt_days}
                                icon={EventAvailableOutlinedIcon}
                                tone="sand"
                            />
                        </div>
                    </LoadingWrapper>
                    <LoadingWrapper isLoading={isLoadingFinancialCard}>
                        {dataFinancialCardLastTimeUpdate?.active && dataFinancialCard && dataFinancialCard?.items && dataFinancialCard?.items.length > 0 && (
                            <p style={{ marginTop: "1rem" }}>{dataFinancialCardLastTimeUpdate?.message}</p>
                        )}

                        {dataFinancialCard && dataFinancialCard?.items && dataFinancialCard?.items.length > 0 && <DataTable columns={tblFields} data={dataFinancialCard?.items} apiUrl={apiPath} mobileCards />}
                    </LoadingWrapper>

                    {dataFinancialCard && dataFinancialCard?.pagination && dataFinancialCard?.pagination?.total_pages > 1 && (
                        <PaginationUI
                            activePage={currentPage}
                            setPage={setPage}
                            numberOfDisplayed={dataFinancialCard?.pagination?.items_per_page ?? 12}
                            numberOfProducts={dataFinancialCard?.pagination.total_items ?? 0}
                            changePage={() => {}}
                            page1={page}
                            setCurrentPage1={setPage}
                        />
                    )}
                </div>
            </div>
        </MainCard>
    );
};

export default AnalyticCardPage;
